import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  width: 17,
  height: 17,
  viewboxWidth: 17,
  viewboxHeight: 17,
};

const SMSReceivedIcon = ({
  width = defaults.width,
  height = defaults.height,
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => {
  return (
    <SVGLoader
      width={width}
      height={height}
      viewboxWidth={viewboxWidth}
      viewboxHeight={viewboxHeight}
      {...rest}
    >
      <path
        d="M16.012 3.775H7.81a.82.82 0 0 0-.82.82v5.557a.82.82 0 0 0 .82.8h1.025v1.435a.41.41 0 0 0 .221.365.41.41 0 0 0 .41-.028l2.56-1.772h3.986a.82.82 0 0 0 .82-.82V4.596a.82.82 0 0 0-.82-.82Zm0 6.254a.103.103 0 0 1-.103.103h-3.998a.41.41 0 0 0-.234.074l-2.022 1.398v-1.062a.41.41 0 0 0-.41-.41H7.912a.103.103 0 0 1-.102-.103V4.7a.103.103 0 0 1 .102-.103h7.997a.103.103 0 0 1 .103.102v5.331Z"
        fill="currentColor"
      />
      <path
        d="M9.45 6.851h4.921a.41.41 0 1 0 0-.82h-4.92a.41.41 0 0 0 0 .82ZM9.45 8.697h4.921a.41.41 0 1 0 0-.82h-4.92a.41.41 0 0 0 0 .82ZM6.31 7.533a.197.197 0 0 0 0-.272L4.333 5.286a.19.19 0 0 0-.22-.06.197.197 0 0 0-.123.198v.889a.099.099 0 0 1-.099.099h-.099c-1.92 0-2.468 1.757-2.832 2.919-.039.13-.079.256-.118.375a.194.194 0 0 0 .075.225c.032.023.07.036.11.035a.186.186 0 0 0 .127-.047 5.49 5.49 0 0 0 .438-.395c.818-.68 1.106-.94 2.003-.94h.296a.099.099 0 0 1 .099.099v.889a.198.198 0 0 0 .343.134L6.31 7.533Z"
        fill="currentColor"
      />
    </SVGLoader>
  );
};

export default SMSReceivedIcon;
